import {
  type CountryIso2,
  defaultCountries,
  parseCountry
} from "react-international-phone";

const FALLBACK_COUNTRY: CountryIso2 = "us";

/**
 * Normalizes an arbitrary country code (e.g. an office's stored ISO2 like "US"
 * or "MY") into a lowercase ISO2 the phone input recognizes.
 *
 * Falls back to "us" when the value is missing or is not a country known to
 * `react-international-phone`, since `usePhoneInput` cannot resolve an unknown
 * default country.
 */
export const resolveDefaultCountry = (country?: string | null): CountryIso2 => {
  const normalized = country?.trim().toLowerCase();
  if (!normalized) {
    return FALLBACK_COUNTRY;
  }

  const isKnownCountry = defaultCountries.some(
    (countryData) => parseCountry(countryData).iso2 === normalized
  );

  return isKnownCountry ? (normalized as CountryIso2) : FALLBACK_COUNTRY;
};
